import script from "./BecomeMysticPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BecomeMysticPanel.vue?vue&type=script&setup=true&lang=js"

import "./BecomeMysticPanel.vue?vue&type=style&index=0&id=fe1a0836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe1a0836"]])

export default __exports__